import tools from 'utils/tools';

const ProtectedRoute = tools.lazyWithRetry(() =>
  import('layouts/RouteAccessModifiers'),
);
const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const PeriodicMaintenanceIndex = tools.lazyWithRetry(() =>
  import('components/pages/PeriodicMaintenance/PeriodicMaintenanceIndex'),
);
const PeriodicMaintenanceAnnounce = tools.lazyWithRetry(() =>
  import('components/pages/PeriodicMaintenance/PeriodicMaintenanceAnnounce'),
);
const PeriodicMaintenanceAnnounceDetails = tools.lazyWithRetry(() =>
  import(
    'components/pages/PeriodicMaintenance/PeriodicMaintenanceAnnounceDetails'
  ),
);
const PeriodicMaintenanceAdd = tools.lazyWithRetry(() =>
  import('components/pages/PeriodicMaintenance/PeriodicMaintenanceAdd'),
);

const periodicMaintenanceRoutes = [
  {
    path: '/periodic-maintenance',
    element: (
      <ProtectedRoute device>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <PeriodicMaintenanceIndex /> },
      { path: 'add', element: <PeriodicMaintenanceAdd /> },
      { path: 'announce', element: <PeriodicMaintenanceAnnounce /> },
      {
        path: 'announce-details/:mileage/:ids',
        element: <PeriodicMaintenanceAnnounceDetails />,
      },
    ],
  },
];

export default periodicMaintenanceRoutes;
